export const ROUTES = {
    HOMEPAGE_ROUTE: '/',
    ABOUTUS_ROUTE: '/aboutus',
    SERVICE_ROUTE: '/service',
    CONTACTUS_ROUTE:'/contactus',
    TERMS_CONDITIONS_ROUTE:'/terms-conditions',
    PRIVACY_POLICY_ROUTE:'/privacy-policy',                 
}